import { Fragment } from "react";
import useStyles from "./styles";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";

const EmailSended = ({email,  ...props }: any) => {
  var classes = useStyles();
  const history = useHistory();
  
  const goBack = (e: any) => {
    e.stopPropagation();
    e.preventDefault();

    history.go(-2);

  }

  return (
    <Fragment>
        <Avatar className={classes.avatar}>
        <EmailOutlinedIcon />
      </Avatar>
      <Typography component="h2" variant="h5">
        Hemos enviado un correo con los pasos a seguir a la siguiente dirección: {email}.
      </Typography>
      <div>
        <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={(e: any) =>goBack(e)}>
            Volver
        </Button>
      </div>
    </Fragment>
  );
};

export default EmailSended;
